import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const drawerWidth = 300;
const menuwidth = 73;
const drawerheight = 48;
const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        height: '100%',
        margin: '0',
        overflow: 'auto',
    },
    root1: {
        display: 'flex',
        width: '100%',
        height: '100%',
        margin: '0',
        '& mui-fixed MuiList-padding': {
            paddingBottom: '61px',
        },
    },
    list: {
        width: 250,
    },
    fullList: {
        width: 'auto',
    },
    appBar: {
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: 500,
        }),
        backgroundColor: '#f5f5fa',
        boxShadow: '0 1px 2px rgba(0,0,0,0.05), 0 4px 4px rgba(0,0,0,0.05)',
        color: '#56555b',
        fontWeight: '500',
        fontSize: '15px',
        fontFamily: 'Rubik',
    },
    headermain: {
        display: 'block',
    },
    headerleft: {
        float: 'left',
        paddingTop: '7px',
    },
    headerright: {
        float: 'right',
        paddingTop: '21px',
        display: 'flex',
        justifyContent: 'space-evenly',
        [theme.breakpoints.down('sm')]: {
            fontSize: '10px',
            width: '100%',
            padding: '10px 0',
            justifyContent: 'space-between',
        },
    },
    headericon: {
        width: '40px',
        height: '40px',
        fontSize: '18px',
        background: '#a6a4d6',
        marginRight: '10px',
        padding: '8px 12px',
        marginTop: '-8px',
        borderRadius: '8px',
        color: '#4e4cac',
        cursor: 'pointer',
    },
    headericon1: {
        width: '40px',
        height: '40px',
        fontSize: '18px',
        background: '#D3DED6',
        marginRight: '10px',
        padding: '8px 12px',
        marginTop: '-8px',
        borderRadius: '8px',
        color: '#b9bed3',
    },
    verticalline: {
        borderLeft: '1px solid hsl(0deg 0% 49%)',
        height: '30px',
        margin: '0 17px',
    },
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: 500,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    drawerPaper: {
        width: drawerWidth,
        paddingBottom: '76px',
        border: 'none',
        boxShadow: '0px 0px 5px #ccc',
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        justifyContent: 'flex-end',
    },
    drawerOpen: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: 500,
        }),
        height: `calc(100% - ${drawerheight}px)`,
        width: drawerWidth,
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: 500,
        }),
        overflowX: 'hidden',
        overflowY: 'hidden',
        boxShadow: '2px 0 6px #ccc',
        width: theme.spacing(7) + 1,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9) + 1,
        },
    },
    nested: {
        padding: '16px 80px  16px',
        borderBottom: '1px solid #8786c7',
        backgroundColor: '#7170bd',
        color: '#FFFFFF',
        '&:hover': {
            backgroundColor: '#7170bd',
            color: '#FFFFFF',
        },
    },

    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        // padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        width: '100%',

        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: 500,
        }),
        marginLeft: -drawerWidth,
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: 500,
        }),
        marginLeft: 0,
    },
    iconmainlist: {
        fontSize: '19px',
        padding: '16px 28px',
        color: '#656060',
        textAlign: 'center',
        '&:hover': {
            color: '#7170bd',
        },
    },
    iconlist: {
        display: 'inline',
        color: '#808080',
        minWidth: '30px',
        textAlign: 'left',
    },
    listitemtext: {
        textAlign: 'left',
        marginLeft: '15px',
        fontFamily: 'Rubik',
    },
    gettext: {
        fontSize: '15px',
        fontWeight: '400',
        fontFamily: 'Rubik',
    },
    footer: {
        bottom: '0px',
        position: 'fixed',
        backgroundColor: '#31333f',
        width: '100%',
        height: '60px',
        zIndex: '1201',
        textAlign: 'center',
        color: 'white',
    },
    footertitle: {
        fontSize: '0.9rem',
        paddingTop: '15px',
    },
    clientlogo: {
        maxWidth: '70%',
        maxHeight: '100%',
        height: 'auto',
    },
    headerImg: {
        paddingTop: '12px',
        width:'300px',
        textAlign: 'center',
        height: '50px',
        // position: 'absolute',
    },
    divider: {
        margin: '0px 28px',
        borderTop: '1px solid #eeeef7',
    },
    menutoggleicon: {
        color: '#333333',
        fontSize: '18px',
    },
    logoutPopover: {
        background: 'white',
        padding: '20px',
    },
    menuList: {
        cursor: 'pointer',
    },
    mainfooter: {
        textAlign: 'center',
        bottom: '0',
        width: '300px',
        position: 'fixed',
        fontSize: '13px',
        fontWeight: '400',
        color: '#818182',
        background: '#fff',
    },
    footercontent: {
        padding: '0px 0',
    },
    ptb10: {
        padding: '10px 0',
    },
    welcomeblock: {
        cursor: 'pointer',
        '&:focus': {
            outline: 'none',
        },
        '& span:focus': {
            outline: 'none',
        },
    },
    signOutBtn: {
        margin: '0 5px',
        padding: '8px',
        height: '40px',
        fontSize: '12px',
        fontWeight: '400 !important',
        textTransform: 'initial',
        '&:hover': {
            backgroundColor: '#4E4CAC',
            color: 'white',
        },
        '@global': {
            '*::-webkit-scrollbar': {
                width: '0.4em',
            },
            '*::-webkit-scrollbar-track': {
                '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
            },
            '*::-webkit-scrollbar-thumb': {
                backgroundColor: 'rgb(0 0 0 / 65%)',
                // outline: '4px solid #f8961d',
            },
        },
    },
    // content: {
    //     [theme.breakpoints.down('sm')]: {
    //         padding: '0',
    //     },
    // },
    // scrollSwipe: {
    //     position: 'relative !important',
    //     '& PrivateSwipeArea-anchorRight': {
    //         width: '0 !important',
    //     },
    // },
}));

export default useStyles;
